import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=076a5e38&scoped=true"
import script from "./Pickup.vue?vue&type=script&lang=js"
export * from "./Pickup.vue?vue&type=script&lang=js"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=076a5e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a5e38",
  null
  
)

export default component.exports